import getApi from '../../api'
import { Survey } from '../../model/Survey'

export const getSurvey = (surveyId: number) => getApi().get<Survey>(`surveys/${surveyId}`)
